/**
 * Gets a "random" number from a probability table.
 *
 * @param table - array of objects: { value, probability }
 * @param table[x].v - the value to return
 * @param table[x].p - the probability to return it. Calculated by adding all probabilities in the table.
 */
module.exports = (table) => {
  const expandedTable = table.reduce((accum, { v, p }) => {
    for (let i = 0; i < p; i++ ){
      accum.push(v);
    }

    return accum;
  }, []);

  return () => {
    const index = Math.floor(Math.random() * expandedTable.length);
    return expandedTable[index];
  };
}
